import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GrafupComponent } from '../paginas/grafup/grafup.component';

import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { EChartOption } from 'echarts';


export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-acceso-qr',
  templateUrl: './acceso-qr.component.html',
  styleUrls: ['./acceso-qr.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ]
})
export class AccesoQRComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  separaDia:boolean=false;
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;

  fIni:string = "";
  fFin:string = "";
  fini=moment().add(0, 'months').startOf("month");
  ffin=moment();
  fecHoy=moment();
  itemHorario:any=[];
  itemHorarioFiltra2:any=[];
  itemDiaSem:any=[];
  itemDiaSemFiltra2:any=[];
  itemDia:any=[];
  itemDiaFiltra2:any=[];
  itemMes:any=[];
  itemMesFiltra2:any=[];
  itemVentaHorario:any=[];
  itemVentaHorarioFiltra2:any=[];
  itemVentaDiaSem:any=[];
  itemVentaDiaSemFiltra2:any=[];
  itemVentaDia:any=[];
  itemVentaDiaFiltra2:any=[];
  itemVentaMes:any=[];
  itemVentaMesFiltra2:any=[];
  passCat:string[]=[];
  passUbi:string[]=[];
  ubicacion:any=[];
  idUbi:number = -1;
  grupo:any=[];
  idGpo:number = -1;
  totEntradas:number = -1;
  totVentas:number = -1;
  usrRol:number = -1;
  verMes:boolean = false;

  chartConHorario:any;
  updateConHorarioOptions:any;
  chartConHorarioOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemHorario.map((item) => item.horario)
    },
    color: ['#D2BF49'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Importe',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  chartConDiaSem:any;
  updateConDiaSemOptions:any;
  chartConDiaSemOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDiaSem.map((item) => item.dia)
    },
    color: ['#D2BF49'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.05],
      axisLabel: {
        fontSize: 11,
        formatter: '{value}'
      }
    },
    yAxis: {
      type: 'category',
      data: null,
      axisLabel:{        
        fontSize: 11
      },
    },
    
    series:[
      ]
  };

  chartConDia:any;
  updateConDiaOptions:any;
  chartConDiaOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDia.map((item) => item.dia)
    },
    color: ['#D2BF49'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Fecha',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  chartConMes:any;
  updateConMesOptions:any;
  chartConMesOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDia.map((item) => item.mes)
    },
    color: ['#D2BF49'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Mes',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  chartVentaHorario:any;
  updateVentaHorarioOptions:any;
  chartVentaHorarioOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemHorario.map((item) => item.horario)
    },
    color: ['#806600'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Importe',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  chartVentaDiaSem:any;
  updateVentaDiaSemOptions:any;
  chartVentaDiaSemOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDiaSem.map((item) => item.dia)
    },
    color: ['#806600'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.05],
      axisLabel: {
        fontSize: 11,
        formatter: '{value}'
      }
    },
    yAxis: {
      type: 'category',
      data: null,
      axisLabel:{        
        fontSize: 11
      },
    },
    
    series:[
      ]
  };

  chartVentaDia:any;
  updateVentaDiaOptions:any;
  chartVentaDiaOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDia.map((item) => item.dia)
    },
    color: ['#806600'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Fecha',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  chartVentaMes:any;
  updateVentaMesOptions:any;
  chartVentaMesOption: EChartOption = {
    legend: {
      bottom:10,
      data: this.itemDia.map((item) => item.mes)
    },
    color: ['#806600'],
    tooltip: {
      backgroundColor: 'rgba(10, 10, 10, 0.8)',
      trigger: 'item',
      textStyle: {
        fontSize: 11,
      },
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      /*formatter: function(params) {
        //console.log(params);
        var txt = "";
        for(var p = 0; p < params.length; p++){
          if(p==0)
            txt = "<b>" + params[p].name + "</b>";
          txt += "<br>" + params[p].marker + " " + params[p].seriesName + ": $ " + params[p].data + " K"
        }
        return  txt;
      }*/
    },
    toolbox: {
      feature: {
          //dataView: {show: true, readOnly: false},
          //restore: {show: true},
          saveAsImage: {
            show: true,
            title: "Guardar imagen"
          },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '40px',
      bottom: '20px',
      containLabel: true
    },   
    xAxis: {
      axisLabel:{        
        rotate: 30,
        fontSize: 9
      },
      type: 'category',  
      data: [],
      textStyle: {
        color: '#23FF85',
        fontSize:9            
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 10
      },
      type: 'value',
      data: {
        textStyle: {
          color: '#23FF85',
          fontSize:9            
        }
      }
    },
    
    series:[      {
      name: 'Mes',
      type: 'bar',
      data: [],
      hoverAnimation: true
    }]
  };

  loadingOption: any =
  {
    text: 'Cargando...',
    color: '#806600',
    textColor: '#000',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    zlevel: 0
  }

  thisForm = new FormGroup({
    separaDia: new FormControl(this.separaDia, []),
    ubi: new FormControl(this.idUbi, []),
    gpo: new FormControl(this.idGpo, [])
  });

  constructor(private dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.usrRol = this.dataService.getCurrentRol();
    this.dataService.getUbicaciones().subscribe(
                    rows => {   
                            this.ubicacion = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnUbicacionesbtenidas());
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.grupo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGruposCargados());
  }

  fnUbicacionesbtenidas(){
    //console.log(this.ubicacion);
    if(this.ubicacion.length>0){
      this.idUbi=this.ubicacion[0].id;
      this.passUbi.push(this.idUbi.toString());
      //console.log("idUbi: " + this.idUbi)
      this.thisForm.controls["ubi"].setValue(this.idUbi);
      this.fnCargaReporte();
    }
  }

  fnGruposCargados(){
    console.log(this.grupo)
    if(this.grupo.length > 0){
      this.idGpo = this.grupo[0].idGrupo;
      this.thisForm.controls["gpo"].setValue(this.idGpo);
    }
  }


  fnCargaReporte(){
    this.dataService.getEntradasDiaSem(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idUbi, this.passCat).subscribe(
                                rows => {   this.itemDiaSem = <any>rows   },          
                                error => this.errMsg = <any>error,
                                () => this.fnReporteDiaSemCargado() );    
      /*this.dataService.getInfMktConHorario(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.passUbi, this.passCat).subscribe(
                                rows => {   this.itemHorario = <any>rows   },          
                                error => this.errMsg = <any>error,
                                () => this.fnReporteHorarioCargado() );    */
      this.dataService.getEntradasHorario(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idUbi, this.passCat).subscribe(
                              rows => {   this.itemHorario = <any>rows   },          
                              error => this.errMsg = <any>error,
                              () => this.fnReporteHorarioCargado() );    
      setTimeout(() => {
        this.dataService.getEntradasDia(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idUbi, this.passCat).subscribe(
                                  rows => {   this.itemDia = <any>rows   },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnReporteDiaCargado() );   
        this.dataService.getEntradasMes(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idUbi, this.passCat).subscribe(
                                  rows => {   this.itemMes = <any>rows   },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnReporteMesCargado() );   
        if(this.usrRol < 11){
              this.dataService.getVentasDiaSem(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idGpo, this.passCat).subscribe(
                                rows => {   this.itemVentaDiaSem = <any>rows   },          
                                error => this.errMsg = <any>error,
                                () => this.fnReporteVentaDiaSemCargado() );    
              /*this.dataService.getVentasHorario(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idGpo, this.passCat).subscribe(
                                        rows => {   this.itemHorario = <any>rows   },          
                                        error => this.errMsg = <any>error,
                                        () => this.fnReporteVentaHorarioCargado() );    */
              this.dataService.getVentasHorario(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idGpo, this.passCat).subscribe(
                                      rows => {   this.itemVentaHorario = <any>rows   },          
                                      error => this.errMsg = <any>error,
                                      () => this.fnReporteVentaHorarioCargado() );    
              setTimeout(() => {
                this.dataService.getVentasDia(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idGpo, this.passCat).subscribe(
                                          rows => {   this.itemVentaDia = <any>rows   },          
                                          error => this.errMsg = <any>error,
                                          () => this.fnReporteVentaDiaCargado() );      
                this.dataService.getVentasMes(this.fini.format("YYYYMMDD"), this.ffin.format("YYYYMMDD"), this.idGpo, this.passCat).subscribe(
                                          rows => {   this.itemVentaMes = <any>rows   },          
                                          error => this.errMsg = <any>error,
                                          () => this.fnReporteVentaMesCargado() );                                             
                }, 75);
        }
      }, 75);

  }


  fnCambiaFecha(tipo, obj){
    //console.log("Cambia fecha: " + tipo);
    //console.log(obj.value);
    //console.log(obj.value.format("YYYY-MM-DD"));
    var auxFF;
    var auxFI;
    if (tipo=="INI"){
      this.fini = moment(obj.value.format("YYYY-MM-DD"));
      auxFI=this.fini;
      auxFF=moment(this.ffin);
    }
    if (tipo=="FIN"){
      this.ffin = moment(obj.value.format("YYYY-MM-DD"));
      auxFI=moment(this.fini);
      auxFF=this.ffin;
    }
    this.fnCargaReporte();
  }

  fnReporteDiaSemCargado(){
    //console.log(this.itemDiaSem);
    this.totEntradas = 0;
    for(var d = 0; d < this.itemDiaSem.length; d++){
      this.totEntradas += this.itemDiaSem[d].numVisitas;
    }
    setTimeout(() => {
      this.updateConDiaSemOptions = {
        legend:{
          data:[],              
        },
        yAxis: [{
          data: this.itemDiaSem.map((item) => item.dia),
          type:'category'
        }],
        series: [{
          name:"# Entradas",
          data: this.itemDiaSem.map((item) => item.numVisitas),
          type:'bar',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteHorarioCargado(){
    //console.log(this.itemHorario);
    setTimeout(() => {
      this.updateConHorarioOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemHorario.map((item) => item.hora),
          //type:'category'
        }],
        series: [{
          name:"# Entradas",
          data: this.itemHorario.map((item) => item.numVisitas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteDiaCargado(){
    //console.log(this.itemDia);
    setTimeout(() => {
      this.updateConDiaOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemDia.map((item) => item.fecha),
          //type:'category'
        }],
        series: [{
          name:"# Entradas",
          data: this.itemDia.map((item) => item.numVisitas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteMesCargado(){
    //console.log(this.itemMes);
    setTimeout(() => {
      this.updateConMesOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemMes.map((item) => item.mes),
          //type:'category'
        }],
        series: [{
          name:"# Entradas",
          data: this.itemMes.map((item) => item.numVisitas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteVentaDiaSemCargado(){
    //console.log(this.itemVentaDiaSem);
    this.totVentas = 0;
    for(var d = 0; d < this.itemVentaDiaSem.length; d++){
      this.totVentas += this.itemVentaDiaSem[d].numVentas;
    }
    setTimeout(() => {
      this.updateVentaDiaSemOptions = {
        legend:{
          data:[],              
        },
        yAxis: [{
          data: this.itemVentaDiaSem.map((item) => item.dia),
          type:'category'
        }],
        series: [{
          name:"# Ventas",
          data: this.itemVentaDiaSem.map((item) => item.numVentas),
          type:'bar',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteVentaHorarioCargado(){
    //console.log(this.itemVentaHorario);
    setTimeout(() => {
      this.updateVentaHorarioOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemVentaHorario.map((item) => item.hora),
          //type:'category'
        }],
        series: [{
          name:"# Ventas",
          data: this.itemVentaHorario.map((item) => item.numVentas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteVentaDiaCargado(){
    //console.log(this.itemDia);
    setTimeout(() => {
      this.updateVentaDiaOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemVentaDia.map((item) => item.fecha),
          //type:'category'
        }],
        series: [{
          name:"# Ventas",
          data: this.itemVentaDia.map((item) => item.numVentas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  fnReporteVentaMesCargado(){
    //console.log(this.itemVentaMes);
    setTimeout(() => {
      this.updateVentaMesOptions = {
        legend:{
          data:[],              
        },
        xAxis: [{
          data: this.itemVentaMes.map((item) => item.mes),
          //type:'category'
        }],
        series: [{
          name:"# Ventas",
          data: this.itemVentaMes.map((item) => item.numVentas),
          //type:'category',
          label: {
            show: true,
            position: 'inside',
            color: 'white'
            }
        }]
      };  
    }, 5);
  }

  onChartConHorarioInit(ev){
    this.chartConHorario = ev;
    //this.chartConLanding.showLoading();
  }
  onChartConDiaSemInit(ev){
    this.chartConDiaSem = ev;
    //this.chartConAlcaldia.showLoading();
  }
  onChartConDiaInit(ev){
    this.chartConDia = ev;
    //this.chartConAlcaldia.showLoading();
  }
  onChartConMesInit(ev){
    this.chartConMes = ev;
    //this.chartConAlcaldia.showLoading();
  }

  onChartVentaHorarioInit(ev){
    this.chartVentaHorario = ev;
    //this.chartConLanding.showLoading();
  }
  onChartVentaDiaSemInit(ev){
    this.chartVentaDiaSem = ev;
    //this.chartConAlcaldia.showLoading();
  }
  onChartVentaDiaInit(ev){
    this.chartVentaDia = ev;
    //this.chartConAlcaldia.showLoading();
  }
  onChartVentaMesInit(ev){
    this.chartVentaMes = ev;
    //this.chartConAlcaldia.showLoading();
  }

  fnSecReSize(seccion, tamaño){
    if(tamaño == 100){
      var aux;
      var chart;
      var options;
      var update;
      if(seccion.id == "divConHorario"){
        aux = <HTMLLabelElement>document.getElementById("lblHorario");
        options = this.chartConHorarioOption;
        chart = this.chartConHorario;
        update = this.updateConHorarioOptions;
      }
      if(seccion.id == "divConDiaSem"){
        aux = <HTMLLabelElement>document.getElementById("lblDiaSem");
        options = this.chartConDiaSemOption;
        chart = this.chartConDiaSem;
        update = this.updateConDiaSemOptions;
      }
      if(seccion.id == "divConDia"){
        aux = <HTMLLabelElement>document.getElementById("lblDia");
        options = this.chartConDiaOption;
        chart = this.chartConDia;
        update = this.updateConDiaOptions;
      }
      if(seccion.id == "divConMes"){
        aux = <HTMLLabelElement>document.getElementById("lblMes");
        options = this.chartConMesOption;
        chart = this.chartConMes;
        update = this.updateConMesOptions;
      }
      if(seccion.id == "divVentaHorario"){
        aux = <HTMLLabelElement>document.getElementById("lblVentaHorario");
        options = this.chartVentaHorarioOption;
        chart = this.chartVentaHorario;
        update = this.updateVentaHorarioOptions;
      }
      if(seccion.id == "divVentaDiaSem"){
        aux = <HTMLLabelElement>document.getElementById("lblVentaDiaSem");
        options = this.chartVentaDiaSemOption;
        chart = this.chartVentaDiaSem;
        update = this.updateVentaDiaSemOptions;
      }
      if(seccion.id == "divVentaDia"){
        aux = <HTMLLabelElement>document.getElementById("lblVentaDia");
        options = this.chartVentaDiaOption;
        chart = this.chartVentaDia;
        update = this.updateVentaDiaOptions;
      }
      if(seccion.id == "divVentaMes"){
        aux = <HTMLLabelElement>document.getElementById("lblVentaMes");
        options = this.chartVentaMesOption;
        chart = this.chartVentaMes;
        update = this.updateVentaMesOptions;
      }
  
      let dialogRef = this.dialog.open(GrafupComponent, {
        width: "95%",
        height: "95%",
        disableClose:false,
        data: { 
          titulo: aux.innerHTML,
          tooltip: aux.title,
          grafo: chart,
          grafoptions: options,
          loadingOption: this.loadingOption,
          updateOption: update,
        }      
      });
    }
    if(tamaño == 2){
      seccion.style.width = "210px";
    }
    if(tamaño == 99){
      if(seccion.id == "divConHorario")
        seccion.style.width = "37%";
      if(seccion.id == "divConDiaSem")
        seccion.style.width = "37%"; 
      if(seccion.id == "divConDia")
        seccion.style.width = "82%";    
      if(seccion.id == "divConMes")
        seccion.style.width = "82%";    
      if(seccion.id == "divVentaHorario")
        seccion.style.width = "37%";
      if(seccion.id == "divVentaDiaSem")
        seccion.style.width = "37%"; 
      if(seccion.id == "divVentaDia")
        seccion.style.width = "82%";    
      if(seccion.id == "divVentaMes")
        seccion.style.width = "82%";    
    }
  }

  
  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    console.log(tipo);
    console.log("onClick: " + idEl);
    console.log(item);
    if(tipo=="UBI"){
      this.idUbi = idEl;
      this.fnCargaReporte();
    }
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.fnCargaReporte();
    }
  }
  

}
